import common from "./fr/common";
import enums from "./fr/enums";
import pages from "./fr/pages";
import component from "./fr/component";

const trads = { common, enums, pages, component };

export default trads;
